<template>
  <slot v-bind="{ getLink, paginator, loadNext, showPreloader }"></slot>
</template>
<script>
import { ref } from 'vue'
import store from 'nette-base-module/js/store'
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'

export default {
  props: {
    paginator: Object, // paginator control name
    // dataKey: String, // path to array with data
    paginatorName: String,
  },
  setup (props) {
    const showPreloader = ref(false)

    const getLink = (page) => {
      return props.paginator.url.replace('123456789', page)
    }

    const loadNext = async (controlName, key) => {
        showPreloader.value = true
        const response = await NetteAjax.ajax({
            url: getLink(props.paginator.page + 1),
            off: ['cache', 'vue-render']
        });

        // append new articles to end
        const data = [ ...store.state.nette.$controls[controlName][key], ...response.$controls[controlName][key] ]
        store.dispatch('nette/updateControl', {
            controlName,
            key,
            data
        })

        // update paginatoru
        store.dispatch('nette/updateControl', {
            controlName: props.paginatorName,
            data: response.$controls[props.paginatorName]
        })

        showPreloader.value = false
    }

    return {
      getLink,
      loadNext,
      showPreloader
    }
  }
}
</script>